import { BuildingTypeEnum } from "../../../shared/Models/enums/BuildingTypeEnum";
import { SurveyStatus } from "../../../shared/Models/enums/SurveySurveyStatus";
import { Quadrant } from "../../survey/inside-survey/models/quadrant.enum";
import { DocumentContactDTO } from "./documentContactDTO";
import * as _ from "lodash";
import { DocumentState } from "./documentState";
import { SnsRecordStatus } from "src/app/shared/Models/enums/SnsRecordStatusEnum";
import { TSAType } from "../../survey/inside-survey/models/tsaType.enum";
import { TemplateLanguage } from "src/app/shared/Models/enums/TemplateLanguage.enum";

export class DocumentListItemDTO {
  buildingId: string;
  addressId: string;
  insideSurveyId: string;
  outsideSurveyId: string;
  buildingLomKey: string;
  addressLomKey: string;
  street: string;
  number: number;
  suffix: string;
  city: string;
  postalCode: number;
  buildingGroupId: string;
  buildingType: BuildingTypeEnum;
  status: SurveyStatus;
  quadrant: Quadrant;
  totalUnits: number;
  tsaSentDate: Date;
  expectedFeedback: Date;
  generalRemarks: string;
  contacts: DocumentContactDTO[];
  signedDocumentUrl: string;
  ownerRemarks: {
    name: string;
    remarks: string;
  };
  printedLanguage: TemplateLanguage;
  signedRemarks: string;
  documentStatus: DocumentState;
  approvedDate: Date;
  tsaSnsUploadStatus: SnsRecordStatus;
  tsaSnsUploadTime: Date;
  ssrSnsUploadStatus: SnsRecordStatus;
  ssrSnsUploadTime: Date;
  noAdminTSA: boolean;
  noTSA: boolean;
  tsa: boolean;
  tsaType?: TSAType;
  figure: any;
  areaId: string;
  defaultOwner: boolean;

  static create(from: any) {
    return new DocumentListItemDTO({
      ...from,
      tsaSentDate: from.tsaSentDate && new Date(from.tsaSentDate),
      expectedFeedback:
        from.expectedFeedback && new Date(from.expectedFeedback),
      approvedDate: from.approvedDate && new Date(from.approvedDate),
      tsaSnsUploadTime:
        from.tsaSnsUploadTime && new Date(from.tsaSnsUploadTime),
      ssrSnsUploadTime:
        from.ssrSnsUploadTime && new Date(from.ssrSnsUploadTime),
      signedDocumentUrl: from.buildingDocumentPhotoUrl,
      signedRemarks: from.signedRejectionReason,
      ownerRemarks: !(from.rejecterName && from.rejectionReason)
        ? undefined
        : {
            name: from.rejecterName,
            remarks: from.rejectionReason,
          },
    });
  }

  get address() {
    return `${this.street} ${this.postalCode} ${this.city}`;
  }

  get approved() {
    return this.documentStatus === DocumentState.Approved;
  }

  get rejected() {
    return this.documentStatus === DocumentState.Rejected;
  }

  get canBeApproved() {
    return this.documentStatus === DocumentState.Uploaded;
  }

  get canBeDeleted() {
    return (
      this.documentStatus === DocumentState.Approved ||
      this.documentStatus === DocumentState.Uploaded
    );
  }

  get canUploadTSA() {
    if (
      this.noAdminTSA &&
      this.expectedFeedback &&
      this.expectedFeedback < new Date()
    )
      return false;
    return this.documentStatus === DocumentState.Printed;
  }

  get signedButRejected() {
    return this.documentStatus === DocumentState.SignedRejected;
  }

  getSurveyId(surveyType: string) {
    switch (surveyType) {
      case "inside":
        return this.insideSurveyId;
      case "outside":
        return this.outsideSurveyId;
    }
  }

  getSurveyTypeByStatus(): string {
    if (!this.insideSurveyId) return "outside";

    return "inside";
  }

  get buildingTypeStr() {
    return BuildingTypeEnum[this.buildingType] ?? "";
  }

  get statusStr() {
    return SurveyStatus[this.status] ?? "";
  }

  get quadrantStr() {
    return Quadrant[this.quadrant] ?? "";
  }

  // Data concat for global filter
  get surveyInfo() {
    return `${this.buildingTypeStr} ${this.statusStr} ${this.quadrantStr} ${this.totalUnits}`;
  }

  constructor(item: Partial<DocumentListItemDTO>) {
    Object.assign(this, item);
  }
}
